export enum UserRoles {
  Supervisor = 'Supervisor',
  Student = 'Student',
}
